export default __webpack_public_path__ + "static/Ozon-9fed2e9a2e493330ebd42a541bb421e0.png";